import {FC} from 'react'
import clsx from 'clsx'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuLinkItem: FC<Props & WithChildren> = ({
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const {config} = useLayout()
  const {app} = config

  const content = (
    <>
      {hasBullet && (
        <span className='menu-bullet'>
          <span className='bullet bullet-dot'></span>
        </span>
      )}
      {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
        <span className='menu-icon'>
          <KTIcon iconName={icon} className='fs-2' />
        </span>
      )}
      {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
        <i className={clsx('bi fs-3', fontIcon)}></i>
      )}
      <span className='menu-title'>{title}</span>
    </>
  )

  return (
    <div className='menu-item'>
      <a
          href={to}
          rel='noopener noreferrer'
          className='menu-link without-sub'
        >
          {content}
        </a>
    </div>
  )
}

export {SidebarMenuLinkItem}
